export default __webpack_public_path__ + "static/images/3ed67ce5.png";